<template>
  <div>
    <form @submit.prevent="addRequest">
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <strong>Create A Request</strong> Elements
                    </div>
                    
                        <b-form-group
                            label="Request Customer:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="requestcustomer" type="text" v-model="request.customer"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Request Member:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="requestmember" type="text" v-model="request.member"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Request Title:"
                            label-for="basicName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="requesttitle" type="text" v-model="request.title"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Date" label-for="date"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input type="date" id="date"  v-model="request.date"></b-form-input>
                        </b-form-group>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-md-10"></div>
                                <div class="col-md-2">
                                    <button class="btn btn-primary">Create</button>
                                </div>
                            </div>
                        </div>  
                </b-card>
            </b-col>
        </b-row>
    </form>
  </div>
</template>

<script>
export default {
    name: 'requestsadd',
    data(){
        return {
        request:{}
        }
    },
    methods: {
        addRequest(){
            let uri = `${process.env.VUE_APP_API_BASE_URL}/requests/add`;
            this.axios.post(uri, this.request).then(() => {
                this.$router.push({name: 'Requests'});
            });
        }   
    }
}
</script>